module.exports = __webpack_public_path__ + "img/Group-1988.e409a2aa.png";